import getLangLocale from 'I18n/utils/getLangLocale';
import { getPreferredLanguage } from 'pricing-pages-lib/utils/getPreferredLanguage';
export const getBrowserLocale = () => {
  const browserLocale = getLangLocale() || getPreferredLanguage().toLowerCase() || 'en-us';
  const preferredCountryCode = window.COUNTRY_CODE_FROM_LOCALE && window.COUNTRY_CODE_FROM_LOCALE.toUpperCase();
  return {
    browserLocale,
    preferredCountryCode
  };
};